import { MasterQuestionConfig } from "../questionnaires/questionnaireConfig/models";

import * as questionIds from "./initialWorkAdjustmentQuestionnaireQuestionIds";

export const initialWorkAdjustmentQuestionnaireMasterConfig: MasterQuestionConfig[] = [
    // Information from OH Report
    {
        id: questionIds.HrManager,
        questionText: "HR/Manager",
        canBeDisabled: false
    },
    {
        id: questionIds.EmployeeSeen,
        questionText: "Employee Seen",
        canBeDisabled: false
    },
    {
        id: questionIds.DateOfBirth,
        questionText: "Date of Birth",
        canBeDisabled: false
    },
    {
        id: questionIds.EmployeeId,
        questionText: "Employee Unique ID",
        canBeDisabled: false
    },
    {
        id: questionIds.EmployerAndDivision,
        questionText: "Employer and Division",
        canBeDisabled: false
    },
    {
        id: questionIds.JobTitle,
        questionText: "Job Title",
        canBeDisabled: false
    },
    {
        id: questionIds.DateOfReport,
        questionText: "Date of Report",
        canBeDisabled: false
    },
    {
        id: questionIds.ExpectedReturnToWorkDate,
        questionText: "Expected Return to Work Date",
        canBeDisabled: false
    },
    {
        id: questionIds.RecommendedAdjustments,
        questionText: "Recommended Adjustments",
        canBeDisabled: false
    },
    {
        id: questionIds.RecommendedEndDate,
        questionText: "Recommended End Date",
        canBeDisabled: false
    },
    // Meeting Record
    {
        id: questionIds.DateOfMeeting,
        questionText: "Date of Meeting",
        canBeDisabled: false
    },
    {
        id: questionIds.NotesFromMeetingUploaded,
        questionText: "Notes from Meeting uploaded",
        canBeDisabled: false
    },
    {
        id: questionIds.WorkAdjustmentType,
        questionText: "Work Adjustment type",
        canBeDisabled: false
    },
    // Adjustments mini-section 0
    {
        id: questionIds.StartDateOfAdjustment0,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment0,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType0,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork0,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime0,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime0,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment0,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 1
    {
        id: questionIds.StartDateOfAdjustment1,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment1,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType1,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork1,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime1,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime1,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment1,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 2
    {
        id: questionIds.StartDateOfAdjustment2,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment2,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType2,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork2,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime2,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime2,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment2,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 3
    {
        id: questionIds.StartDateOfAdjustment3,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment3,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType3,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork3,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime3,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime3,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment3,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 4
    {
        id: questionIds.StartDateOfAdjustment4,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment4,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType4,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork4,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime4,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime4,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment4,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 5
    {
        id: questionIds.StartDateOfAdjustment5,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment5,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType5,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork5,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime5,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime5,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment5,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 6
    {
        id: questionIds.StartDateOfAdjustment6,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment6,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType6,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork6,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime6,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime6,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment6,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 7
    {
        id: questionIds.StartDateOfAdjustment7,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment7,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType7,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork7,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime7,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime7,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment7,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 8
    {
        id: questionIds.StartDateOfAdjustment8,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment8,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType8,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork8,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime8,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime8,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment8,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 9
    {
        id: questionIds.StartDateOfAdjustment9,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment9,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType9,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork9,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime9,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime9,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment9,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 10
    {
        id: questionIds.StartDateOfAdjustment10,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment10,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType10,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork10,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime10,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime10,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment10,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 11
    {
        id: questionIds.StartDateOfAdjustment11,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment11,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType11,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork11,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime11,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime11,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment11,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 12
    {
        id: questionIds.StartDateOfAdjustment12,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment12,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType12,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork12,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime12,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime12,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment12,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 13
    {
        id: questionIds.StartDateOfAdjustment13,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment13,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType13,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork13,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime13,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime13,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment13,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 14
    {
        id: questionIds.StartDateOfAdjustment14,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment14,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType14,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork14,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime14,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime14,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment14,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 15
    {
        id: questionIds.StartDateOfAdjustment15,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment15,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType15,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork15,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime15,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime15,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment15,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 16
    {
        id: questionIds.StartDateOfAdjustment16,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment16,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType16,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork16,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime16,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime16,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment16,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 17
    {
        id: questionIds.StartDateOfAdjustment17,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment17,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType17,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork17,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime17,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime17,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment17,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 18
    {
        id: questionIds.StartDateOfAdjustment18,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment18,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType18,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork18,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime18,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime18,
        questionText: "End time",
        canBeDisabled: false
    },
    {
        id: questionIds.IsThisPatternTheSameForTheWholeWorkAdjustment18,
        questionText: "Is this pattern the same for the whole work adjustment?",
        canBeDisabled: false
    },
    // Adjustments mini-section 19
    {
        id: questionIds.StartDateOfAdjustment19,
        questionText: "Start date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.EndDateOfAdjustment19,
        questionText: "End date of adjustment",
        canBeDisabled: false
    },
    {
        id: questionIds.ShiftType19,
        questionText: "Shift type",
        canBeDisabled: false
    },
    {
        id: questionIds.DaysPlannedForWork19,
        questionText: "Days planned for work",
        canBeDisabled: false
    },
    {
        id: questionIds.StartTime19,
        questionText: "Start time",
        canBeDisabled: false
    },
    {
        id: questionIds.EndTime19,
        questionText: "End time",
        canBeDisabled: false
    },

    {
        id: questionIds.ExpectedReturnToWorkDateIfKnown,
        questionText: "Expected Return to work date (if known)",
        canBeDisabled: false
    },
    {
        id: questionIds.WorkAdjustmentReviewDate,
        questionText: "Work Adjustment Review Date",
        canBeDisabled: false
    },
    // Closure of Adjustments
    {
        id: questionIds.CloseThisWorkAdjustmentCase,
        questionText: "Tick this box to confirm you wish to close this work adjustment case",
        canBeDisabled: false
    },
    {
        id: questionIds.ReasonForClosure,
        questionText: "Reason for Closure",
        canBeDisabled: false
    },
    {
        id: questionIds.DateOfClosure,
        questionText: "Date of Closure",
        canBeDisabled: false
    },
    {
        id: questionIds.NotesFromClosure,
        questionText: "Notes from Closure",
        canBeDisabled: false
    }
];
